import { render } from "./TextInfo.vue?vue&type=template&id=60a1c954&scoped=true"
import script from "./TextInfo.vue?vue&type=script&lang=js"
export * from "./TextInfo.vue?vue&type=script&lang=js"

import "./TextInfo.vue?vue&type=style&index=0&id=60a1c954&scoped=true&lang=css"

import exportComponent from "/var/www/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60a1c954"]])

export default __exports__